export const Container = ({ children }) => {
    return <div className="w-[100%] px-4 mt-8">{children}</div>;
};
